import React from 'react';
import { RetailAllCategoryCards as  DesignRetailAllCategoryCards } from 'cb-design-system';

const RetailAllCategoryCards = (props) => {
  return (
    <DesignRetailAllCategoryCards {...props}/>
  );
};

export default RetailAllCategoryCards;